"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_CONTEXT_CACHE_TTL = exports.AUTH_CONTEXT_CACHE_KEY = exports.AUTH_CONTEXT_QUEUE = void 0;
exports.AUTH_CONTEXT_QUEUE = 'AUTH_CONTEXT_QUEUE';
exports.AUTH_CONTEXT_CACHE_KEY = 'AUTH_CONTEXT_CACHE';
exports.AUTH_CONTEXT_CACHE_TTL = 30000;
